import Immutable from 'immutable';
import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setAll = (state, { allRejectionReasons }) => {
  if (!allRejectionReasons) return state;
  return state.merge({ allRejectionReasons });
};
const setLoader = (state, { showLoader }) => {
  return state.merge({ showLoader });
};

const setAllRejectionReasons = (state, { allRejectionReasonsData }) => {
  if (!allRejectionReasonsData) return state;
  return state.merge({ allRejectionReasonsData });
};
const setCanAddIsPriority = (state, { canAddIsPriority }) => {
  return state.merge({ canAddIsPriority });
};
const setIsLoadingCanAddPriority = (state, { isLoadingCanAddPriority }) => {
  return state.merge({ isLoadingCanAddPriority });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_ALL,
    actionFunction: setAll,
  },
  {
    actionType: ActionTypes.SET_LOADER_STATUS,
    actionFunction: setLoader,
  },
  {
    actionType: ActionTypes.SET_ALL_REJECTION_REASONS,
    actionFunction: setAllRejectionReasons,
  },
  {
    actionType: ActionTypes.SET_CAN_ADD_IS_PRIORITY_REJECTION_REASON,
    actionFunction: setCanAddIsPriority,
  },
  {
    actionType: ActionTypes.SET_IS_LOADING_CAN_ADD_PRIORITY,
    actionFunction: setIsLoadingCanAddPriority,
  },
];
